import { baseApi } from "./base.api";

export const patientVisitApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchPatientVisits: build.query({
      query: (params) => ({ url: "/patient-visit/fetch", method: "GET", params }),
      providesTags: ["PatientVisit"],
    }),
    fetchTrashedPatientVisits: build.query({
      query: (params) => ({ url: "/patient-visit/fetch/trashed", method: "GET", params }),
      providesTags: ["PatientVisit"],
    }),
    fetchReferredPatientVisitsAll: build.query({
      query: () => ({ url: "/patient-visit/fetch/all", method: "GET" }),
      providesTags: ["PatientVisit"],
    }),
    fetchPatientById: build.query({
      query: (id) => ({ url: `/patient-visit/fetch/${id}`, method: "GET" }),
      providesTags: ["PatientVisit"],
    }),
    createPatientVisit: build.mutation({
      query: (body) => ({ url: "/patient-visit/create", method: "POST", body }),
      invalidatesTags: ["PatientVisit"],
    }),
    updatePatientVisit: build.mutation({
      query: ({ id, body }) => ({ url: `/patient-visit/update/${id}`, method: "PUT", body }),
      invalidatesTags: ["PatientVisit"],
    }),
    restorePatientVisit: build.mutation({
      query: (id) => ({ url: `/patient-visit/restore/${id}`, method: "PUT" }),
      invalidatesTags: ["PatientVisit"],
    }),
    bulkRestorePatientVisits: build.mutation({
      query: (body) => ({ url: "/patient-visit/bulk-restore", method: "POST", body }),
      invalidatesTags: ["PatientVisit"],
    }),
    deletePatientVisit: build.mutation({
      query: (id) => ({ url: `/patient-visit/delete/${id}`, method: "DELETE" }),
      invalidatesTags: ["PatientVisit"],
    }),
    bulkDeletePatientVisits: build.mutation({
      query: (body) => ({ url: "/patient-visit/bulk-delete", method: "POST", body }),
      invalidatesTags: ["PatientVisit"],
    }),
    destroyPatientVisit: build.mutation({
      query: (id) => ({ url: `/patient-visit/destroy/${id}`, method: "DELETE" }),
      invalidatesTags: ["PatientVisit"],
    }),
    bulkDestroyPatientVisits: build.mutation({
      query: (body) => ({ url: "/patient-visit/bulk-destroy", method: "POST", body }),
      invalidatesTags: ["PatientVisit"],
    }),
  }),
});

export const {
  useFetchPatientVisitsQuery,
  useFetchTrashedPatientVisitsQuery,
  useFetchPatientByIdQuery,
  useCreatePatientVisitMutation,
  useUpdatePatientVisitMutation,
  useRestorePatientVisitMutation,
  useBulkRestorePatientVisitsMutation,
  useDeletePatientVisitMutation,
//   usefetchReferredPatientVisitsAllQuery,
  useBulkDeletePatientVisitsMutation,
  useDestroyPatientVisitMutation,
  useBulkDestroyPatientVisitsMutation,
} = patientVisitApi;
